import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Avatar, Button, Menu, MenuItem } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';

import { COLORS } from 'helpers/enums/colors';
import { SIZES } from 'helpers/enums/sizes';

import { ViewContainer, ViewContent } from 'styles/view';

export const NavbarContainer = styled(ViewContainer)`
  && {
    padding-bottom: 0;
  }
`;

export const NavbarContent = styled(ViewContent)<{ isPublic: boolean }>`
  && {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    color: ${({ isPublic }) => (isPublic ? COLORS.white : COLORS.grayScorpion)};
    background-color: ${({ isPublic }) => (isPublic ? COLORS.blueRibbon : COLORS.white)};
  }
`;

export const NavbarMenuButton = styled(MenuIcon)`
  && {
    display: none;
    color: ${COLORS.grayScorpion};
    cursor: pointer;

    &:hover {
      color: ${COLORS.blueRibbon};
    }

    @media (max-width: ${SIZES.bigTablet}px) {
      display: block;
    }
  }
`;

export const NavbarAccountButton = styled(Button)<{ isPublic?: boolean }>`
  && {
    padding: 0;

    ${({ isPublic = false }) =>
      isPublic &&
      css`
        padding: 12px;
        color: ${COLORS.white};
        font-size: 16px;
        font-weight: 400;
        text-transform: none;
      `}
  }
`;

export const NavbarProfileAvatar = styled(Avatar)`
  && {
    background-color: ${COLORS.blueRibbon};
    color: ${COLORS.white};
    font-family: 'Montserrat', Helvetica, Arial, serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const NavbarMenu = styled(Menu)<{ isPublic?: boolean }>`
  && {
    .MuiPaper-root {
      top: 80px !important;
      left: auto !important;
      right: 25px;

      ${({ isPublic = false }) =>
        isPublic &&
        css`
          padding: 12px 20px;
          background-color: ${COLORS.blueRibbon};

          ul {
            float: right;
          }
        `}

      @media (max-width: ${SIZES.bigTablet}px) {
        left: 25px !important;
      }
    }
  }
`;

export const NavbarMenuItem = styled(MenuItem)`
  && {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 16px;
  }
`;

export const NavbarMenuItemLabel = styled.span`
  margin-left: 10px;
  color: ${COLORS.grayScorpion};
  font-family: 'Montserrat', Helvetica, Arial, serif;
  font-size: 14px;
  line-height: 20px;
`;

export const NavbarNavlinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const NavbarNavlinkButton = styled(NavLink)`
  && {
    padding: 10px;
    color: ${COLORS.white};
    border-radius: 4px;

    &.active {
      color: ${COLORS.blueRibbon};
      background-color: ${COLORS.white};
    }
  }
`;

export const NavbarLogoutButton = styled(Button)`
  && {
    padding: 10px;
    color: ${COLORS.white};
    border-radius: 4px;
    text-transform: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5;
  }
`;
